import React from 'react';

type SpinnerLoaderProps = {
  className?: string;
}

const SpinnerLoader: React.FC<SpinnerLoaderProps> = (props) => {
  const { className } = props;

  const spinnerClassName = `c-spinner-loader animate-spin rounded-full border-4 border-solid border-primary border-t-transparent h-16 w-16 ${className}`;

  return (
    <div className={spinnerClassName}></div>
  );
};

export default SpinnerLoader;
